import client from './client';
export const adminAPI = {
    async getOverview() {
        const response = await client.get('/admin/overview');
        return response.data.data;
    },
    async getEmailConfig() {
        const response = await client.get('/admin/email-config');
        return response.data.data;
    },
    async updateEmailConfig(data) {
        const response = await client.put('/admin/email-config', data);
        return response.data.data;
    },
    async testEmailConfig(testEmail) {
        const response = await client.post('/admin/email-config/test', { testEmail });
        return response.data.data;
    },
    async listTenants(params) {
        const response = await client.get('/admin/tenants', { params });
        return response.data.data;
    },
    async listPendingRegistrations(params) {
        const response = await client.get('/admin/pending-registrations', { params });
        return response.data.data;
    },
    async approvePendingRegistration(id) {
        const response = await client.post(`/admin/pending-registrations/${id}/approve`);
        return response.data.data;
    },
    async resendPendingRegistration(id) {
        const response = await client.post(`/admin/pending-registrations/${id}/resend`);
        return response.data.data;
    },
    async deletePendingRegistration(id) {
        const response = await client.delete(`/admin/pending-registrations/${id}`);
        return response.data.data;
    },
    async updateTenant(id, data) {
        const response = await client.patch(`/admin/tenants/${id}`, data);
        return response.data.data;
    },
    async deleteTenant(id, reason) {
        const response = await client.delete(`/admin/tenants/${id}`, { data: { reason } });
        return response.data.data;
    },
    async refillTenantCredits(id, amount, description) {
        const response = await client.post(`/admin/tenants/${id}/credits/refill`, { amount, description });
        return response.data.data;
    },
    async resetTenantPassword(id, reason) {
        const response = await client.post(`/admin/tenants/${id}/password-reset`, { reason });
        return response.data.data;
    },
    async listCreditHistory(params) {
        const response = await client.get('/admin/credits/history', { params });
        return response.data.data;
    },
    async listScans(params) {
        const response = await client.get('/admin/scans', { params });
        return response.data.data;
    },
    async getGitHubAppConfig() {
        const response = await client.get('/admin/github/app-config');
        return response.data.data;
    },
    async updateGitHubAppConfig(data) {
        const response = await client.put('/admin/github/app-config', data);
        return response.data.data;
    },
    async listGitHubSources(params) {
        const response = await client.get('/admin/github/sources', { params });
        return response.data.data;
    },
    async deleteGitHubSource(id, reason) {
        const response = await client.delete(`/admin/github/sources/${id}`, { data: { reason } });
        return response.data.data;
    },
    async listAuditLogs(params) {
        const response = await client.get('/admin/audit-logs', { params });
        return response.data.data;
    },
    async getTenantAuditLogs(params) {
        const response = await client.get('/admin/audit-logs', { params });
        return response.data.data;
    },
    async listFilterWords() {
        const response = await client.get('/admin/contact-filter');
        return response.data.data;
    },
    async createFilterWord(data) {
        const response = await client.post('/admin/contact-filter', data);
        return response.data.data;
    },
    async updateFilterWord(id, data) {
        const response = await client.patch(`/admin/contact-filter/${id}`, data);
        return response.data.data;
    },
    async deleteFilterWord(id) {
        const response = await client.delete(`/admin/contact-filter/${id}`);
        return response.data.data;
    },
};
